

import React from 'react';
import './Typeofmember.css';
import membership from '../images/Membership.jpg';
import Startanewclub from '../images/Membership/Startanewclub.jpg'
import { Link } from 'react-router-dom';
// import m1 from '../images/Membership/1.png';
// import m2 from '../images/Membership/2.jpg';
// import m3 from '../images/Membership/3.png';
// import m4 from '../images/Membership/4.jpg';
// import m5 from '../images/Membership/5.jpg';
import startaleo from '../images/Membership/Startaclub.jpg'


const StartAnewClub = () => {
  return (
    <>
      <div className="membership-container">
        {/* Sidebar */}
        <div className="sidebar">
          <h3 className="sidebar-title">Categories</h3>
          <ul className="category-list scrollable-list">
              <Link to='/typesofmembers'> <li >
              <img src={membership} alt="Membership" />
              Types of Members
            </li></Link>
            <li  style={{fontWeight:'bold',color:'#005399'}}>
              <img src={Startanewclub} alt="Most Viewed" />
              Start a new club
            </li>
          <Link to='/StartaLeoclub'>   <li>
              <img src={startaleo} alt="Membership" />
              Start a Leo Club
            </li> </Link>
         <Link to='/TypesofClub'>    <li>
              <img src={membership} alt="Membership" />
              Types of Clubs
            </li> </Link>
         <Link to='/membershipgrant'>    <li>
              <img src={membership} alt="Membership" />
              Membership Grants
            </li> </Link>
            <Link to='/newMembershipform'>     <li>
              <img src={membership} alt="Membership" />
              New Member Form
            </li></Link>
             <Link to='/memberInductionCeremony'>    <li>
              <img src={membership} alt="Membership" />
              Member Induction Ceremony
            </li></Link>
           <Link to='/memberOrientation'>      <li>
              <img src={membership} alt="Membership" />
              New Member Orientation
            </li></Link>
                <Link to='/myLciLogintocheckdues'>       <li>
              <img src={membership} alt="Membership" />
              My LCI Login to Check dues
            </li></Link>
               <Link to='/payMembershipDues'>        <li>
              <img src={membership} alt="Membership" />
              Pay Membership Dues
            </li></Link>
             <Link to='/membershipAwards'>          <li>
              <img src={membership} alt="Membership" />
              Membership Awards
            </li></Link>
               <Link to='/leopAwards'>       <li>
              <img src={membership} alt="Membership" />
              Leo Awards
            </li></Link>
          </ul>
        </div>
        
        {/* Right Content Area with Cards */}
        <div className="membership-content">
          {/* Card 1 */}
          <div className="membership-card">
            <div className="card-image">
              <img src={Startanewclub} alt="Leo-Lion Membership" />
            </div>
            <div className="card-content">
               <h2 >Start A new Club</h2>
          <p>
            Starting a Lions club offers you the opportunity to create the club you want to see in your community and serve the causes you care about with the service-minded people you care about most.
          </p>
         
            </div>
          </div>

          {/* Card 2 */}
          {/* <div className="membership-card">
            <div className="card-content">
              <h2>Regular Member</h2>
              <p>
                A Regular Member is someone who joins a Lions club independently. They have full rights and responsibilities and are eligible to vote and hold office within the club.
              </p>
            </div>
            <div className="card-image">
              <img src={m2} alt="Regular Membership" />
            </div>
          </div>

          {/* Card 3 */}
          {/* <div className="membership-card">
            <div className="card-image">
              <img src={m3} alt="Student Membership" />
            </div>
            <div className="card-content">
              <h2>Student Member</h2>
              <p>
                Students enrolled in an educational institution can join Lions clubs and receive discounted dues, allowing young leaders to get involved in service early in life.
              </p>
            </div>
          </div> */}

          {/* Card 4 */}
          {/* <div className="membership-card">
            <div className="card-content">
              <h2>Honorary Member</h2>
              <p>
                An Honorary Member is a special status granted by a Lions club in recognition of distinguished service or contribution to the community. They are not required to pay dues.
              </p>
            </div>
            <div className="card-image">
              <img src={m4} alt="Honorary Membership" />
            </div>
          </div> */}

          {/* Additional Card */}
          {/* <div className="membership-card">
            <div className="card-image">
              <img src={m5} alt="Life Membership" />
            </div>
            <div className="card-content">
              <h2>Life Member</h2>
              <p>
                A Life Member is someone who has made significant contributions or has been a member for a long time. They are granted lifetime membership and do not need to renew their membership annually.
              </p>
            </div>
            
          </div> */}
        </div>
      </div>
    </>
  );
};

export default StartAnewClub;
